import { render, staticRenderFns } from "./user_add.vue?vue&type=template&id=285ccd88&"
import script from "./user_add.vue?vue&type=script&lang=ts&"
export * from "./user_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports